import type { TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export function Textarea({ className, ...props }: TextareaProps) {
  return (
    <textarea
      className={cn(
        "w-full rounded-md border border-border bg-surface-elevated px-3 py-2.5",
        "text-sm text-primary placeholder:text-muted",
        "outline-none focus:border-brand-cyan/60 focus:ring-1 focus:ring-brand-cyan/30",
        "transition-colors resize-none",
        className,
      )}
      {...props}
    />
  );
}
